import { render } from "./FormTags.vue?vue&type=template&id=a6d4d82c"
import script from "./FormTags.vue?vue&type=script&lang=ts"
export * from "./FormTags.vue?vue&type=script&lang=ts"
script.render = render

export default script